import React, { useReducer } from 'react';
import axios from 'axios';
import StoreContext from './storeContext';
import storeReducer from './storeReducer';

const StoreState = props => {
    const initialState = {
        stores: [],
        current: null,
        loading: true,
        error: null
    };

    const [state, dispatch] = useReducer(storeReducer, initialState);

    // Get Stores
    const getStores = async () => {
        try {
            const res = await axios.get('/api/stores');

            dispatch({
                type: 'GET_STORES',
                payload: res.data
            });
        } catch (err) {
            dispatch({
                type: 'STORE_ERROR',
                payload: err.response.msg
            });
        }
    };

    // Add Store
    const addStore = async store => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            const res = await axios.post('/api/stores', store, config);

            dispatch({
                type: 'ADD_STORE',
                payload: res.data
            });
        } catch (err) {
            dispatch({
                type: 'STORE_ERROR',
                payload: err.response.msg
            });
        }
    };

    // Delete Store
    const deleteStore = async id => {
        try {
            await axios.delete(`/api/stores/${id}`);

            dispatch({
                type: 'DELETE_STORE',
                payload: id
            });
        } catch (err) {
            dispatch({
                type: 'STORE_ERROR',
                payload: err.response.msg
            });
        }
    };

    // Update Store
    const updateStore = async store => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            const res = await axios.put(`/api/stores/${store.store_id}`, store, config);

            dispatch({
                type: 'UPDATE_STORE',
                payload: res.data
            });
        } catch (err) {
            dispatch({
                type: 'STORE_ERROR',
                payload: err.response.msg
            });
        }
    };

    return (
        <StoreContext.Provider
            value={{
                stores: state.stores,
                current: state.current,
                loading: state.loading,
                error: state.error,
                getStores,
                addStore,
                deleteStore,
                updateStore
            }}
        >
            {props.children}
        </StoreContext.Provider>
    );
};

export default StoreState;
